import translate, { TranslationKey } from "../../common/functions/translate";
import { SecurityCodeMethod } from "../hooks/useMfaApi";
import { SuccessAlert } from "./SuccessAlert";
import formatMfaChannel from '../../common/functions/formatMfaChannel';
import { useEffect } from "react";
import { alertImpression } from "../../common/analytics";

interface MfaSendSuccessAlertProps {
    isResend: boolean
    type: SecurityCodeMethod,
    value: string
}
export const MfaSendSuccessAlert = (props: MfaSendSuccessAlertProps) => {
    const { isResend, type, value } = props;
    const mfaSendSuccessHeading: TranslationKey = (isResend) ? `we_resent_code_${type}` : `we_sent_code_${type}`;
    const mfaSendSuccessBody1: TranslationKey = `mfa_sent_${type}_1`;
    const mfaSendSuccessBody2: TranslationKey = `mfa_sent_${type}_2`;
    const formattedClassName = [
        'ds-u-text-transform--uppercase',
        'ds-u-font-weight--semibold',
        `mfa-formatted-${type}`,
    ].join(' ');

    useEffect(() => {
        alertImpression({
            heading: translate(mfaSendSuccessHeading),
            text: [translate(mfaSendSuccessBody1), translate(mfaSendSuccessBody2)].join(' '),
            alertType: 'success'
        })
    }, [mfaSendSuccessBody1, mfaSendSuccessHeading, mfaSendSuccessBody2]);

    return <SuccessAlert heading={translate(mfaSendSuccessHeading)}>
        {translate(mfaSendSuccessBody1)}{" "}
        <span className={formattedClassName}>{formatMfaChannel(value)}</span>{" "}
        {translate(mfaSendSuccessBody2)}{" "}
        {!isResend && type === 'email' && translate('check_your_spam_folder')}
        {isResend && translate('mfa_resent_multiple_codes')}
    </SuccessAlert>;
}